module.exports = __webpack_public_path__ + "img/logo.569df37c.png";